import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const TAG_CLASS_NAME = tv({
  base: clsx(
    "flex gap-[4px] rounded-[4px] px-[6px] py-[3px] h-[24px]",
    // hover
    "hover:border hover:border-grayScale-200 hover:py-[2px]",
  ),
  variants: {
    color: {
      "orange-deep": "bg-expressive-orange-deep [&_svg]:fill-grayScale-0 text-base-0",
      "sky-deep": "bg-expressive-sky-deep [&_svg]:fill-grayScale-0 text-base-0",
      "purple-deep": "bg-expressive-purple-deep [&_svg]:fill-grayScale-0 text-base-0",
      "pink-deep": "bg-expressive-pink-deep [&_svg]:fill-grayScale-0 text-base-0",
      "yellowGreen-deep": "bg-expressive-yellowGreen-deep [&_svg]:fill-grayScale-0 text-base-0",
      "bluePurple-deep": "bg-expressive-bluePurple-deep [&_svg]:fill-grayScale-0 text-base-0",
      "blueGreen-deep": "bg-expressive-blueGreen-deep [&_svg]:fill-grayScale-0 text-base-0",
      "orange-pale": "bg-expressive-orange-pale [&_svg]:fill-grayScale-300 text-base-400",
      "sky-pale": "bg-expressive-sky-pale [&_svg]:fill-grayScale-300 text-base-400",
      "purple-pale": "bg-expressive-purple-pale [&_svg]:fill-grayScale-300 text-base-400",
      "pink-pale": "bg-expressive-pink-pale [&_svg]:fill-grayScale-300 text-base-400",
      "yellowGreen-pale": "bg-expressive-yellowGreen-pale [&_svg]:fill-grayScale-300 text-base-400",
      "bluePurple-pale": "bg-expressive-bluePurple-pale [&_svg]:fill-grayScale-300 text-base-400",
      "blueGreen-pale": "bg-expressive-blueGreen-pale [&_svg]:fill-grayScale-300 text-base-400",
    },
    withIcon: {
      true: clsx("pl-[6px] pr-[8px]", "hover:pl-[5px] hover:pr-[7px]"),
      false: clsx("px-[8px]", "hover:px-[7px]"),
    },
  },
});
